// firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Replace with your Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyC7LfB31BxcTh5B16QyQ6l1FNqfuiLOMTw",
  authDomain: "tycah-e624c.firebaseapp.com",
  projectId: "tycah-e624c",
  storageBucket: "tycah-e624c.firebasestorage.app",
  messagingSenderId: "481278388673",
  appId: "1:481278388673:web:6155a014db963bd5866740",
  measurementId: "G-K3XK5QG3GJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };
